import React, { useEffect, useRef } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const CarSlider = () => {
  const options = {
    loop: true,
    animateIn: "fadeIn",
    margin: 10,
    autoplayTimeout: 3000,
    nav: true,
    autoplay: 3000,
    mouseDrag: false,
    touchDrag: false,
    slideSpeed: 2000,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  return (
    <div className="row mt-5 pt-5 mb-5">
      <div className="col-md-12">
        <OwlCarousel
          className="owl-carousel owl-theme ct_login_slider"
          {...options}
        >
          <div className="item">
            <div className="ct_slider_item">
              <div
                className="ct_gradient_box"
                style={{
                  background: "linear-gradient(180deg, #0B0000 0%, #666060 100%)",
                  borderRadius: "32px",
                  padding: "72px 32px 40px 32px",
                  maxWidth: "600px",
                  width: "100%",
                  minHeight: "600px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                  margin: "0 auto"
                }}
              >
                <h1 className="ct_fs_64 text-white" style={{ textAlign: 'center', marginTop: '0', marginBottom: '12px', lineHeight: 1.1, fontSize: '1.5rem', fontWeight: 600 }}>SUV</h1>
                <p className="text-white mb-2" style={{ fontSize: '0.85rem', opacity: 0.8, textAlign: 'center', fontWeight: 400 }}>
                Perfect for family trips and large groups. Spacious and comfortable for long distances.
                </p>
                <div className="d-flex align-items-center mb-3" style={{ justifyContent: 'center' }}>
                  <div className="d-flex align-items-center me-4">
                    <i className="fas fa-users text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>7 Passengers</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="fas fa-suitcase text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>4 Suitcases</span>
                  </div>
                </div>
                <img src="../assets/img/Black_Suv.png" alt="SUV" style={{ maxWidth: '95%', maxHeight: '364px', height: 'auto', marginTop: '24px', borderRadius: '16px', alignSelf: 'center', objectFit: 'contain' }} />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="ct_slider_item">
              <div
                className="ct_gradient_box"
                style={{
                  background: "linear-gradient(180deg, #0B0000 0%, #666060 100%)",
                  borderRadius: "32px",
                  padding: "72px 32px 40px 32px",
                  maxWidth: "600px",
                  width: "100%",
                  minHeight: "600px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                  margin: "0 auto"
                }}
              >
                <h1 className="ct_fs_64 text-white" style={{ textAlign: 'center', marginTop: '0', marginBottom: '12px', lineHeight: 1.1, fontSize: '1.5rem', fontWeight: 600 }}>Luxury Sedan</h1>
                <p className="text-white mb-2" style={{ fontSize: '0.85rem', opacity: 0.8, textAlign: 'center', fontWeight: 400 }}>
                Elegance and comfort at their finest. Perfect for business travel and special occasions.
                </p>
                <div className="d-flex align-items-center mb-3" style={{ justifyContent: 'center' }}>
                  <div className="d-flex align-items-center me-4">
                    <i className="fas fa-users text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>5 Passengers</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="fas fa-suitcase text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>3 Suitcases</span>
                  </div>
                </div>
                <img src="../assets/img/Black_Sclass.png" alt="Luxury Sedan" style={{ maxWidth: '95%', maxHeight: '364px', height: 'auto', marginTop: '24px', borderRadius: '16px', alignSelf: 'center', objectFit: 'contain' }} />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="ct_slider_item">
              <div
                className="ct_gradient_box"
                style={{
                  background: "linear-gradient(180deg, #0B0000 0%, #666060 100%)",
                  borderRadius: "32px",
                  padding: "72px 32px 40px 32px",
                  maxWidth: "600px",
                  width: "100%",
                  minHeight: "600px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                  margin: "0 auto"
                }}
              >
                <h1 className="ct_fs_64 text-white" style={{ textAlign: 'center', marginTop: '0', marginBottom: '12px', lineHeight: 1.1, fontSize: '1.5rem', fontWeight: 600 }}>Luxury 4×4</h1>
                <p className="text-white mb-2" style={{ fontSize: '0.85rem', opacity: 0.8, textAlign: 'center', fontWeight: 400 }}>
                Power and luxury combined. Perfect for off-road adventures and challenging terrain.
                </p>
                <div className="d-flex align-items-center mb-3" style={{ justifyContent: 'center' }}>
                  <div className="d-flex align-items-center me-4">
                    <i className="fas fa-users text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>6 Passengers</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="fas fa-suitcase text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>5 Suitcases</span>
                  </div>
                </div>
                <img src="../assets/img/Luxury_offroad.png" alt="Luxury 4x4" style={{ maxWidth: '95%', maxHeight: '364px', height: 'auto', marginTop: '24px', borderRadius: '16px', alignSelf: 'center', objectFit: 'contain' }} />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="ct_slider_item">
              <div
                className="ct_gradient_box"
                style={{
                  background: "linear-gradient(180deg, #0B0000 0%, #666060 100%)",
                  borderRadius: "32px",
                  padding: "72px 32px 40px 32px",
                  maxWidth: "600px",
                  width: "100%",
                  minHeight: "600px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                  margin: "0 auto"
                }}
              >
                <h1 className="ct_fs_64 text-white" style={{ textAlign: 'center', marginTop: '0', marginBottom: '12px', lineHeight: 1.1, fontSize: '1.5rem', fontWeight: 600 }}>Electric Vehicle</h1>
                <p className="text-white mb-2" style={{ fontSize: '0.85rem', opacity: 0.8, textAlign: 'center', fontWeight: 400 }}>
                Eco-friendly and sustainable transportation. Zero emissions with premium comfort and technology.
                </p>
                <div className="d-flex align-items-center mb-3" style={{ justifyContent: 'center' }}>
                  <div className="d-flex align-items-center me-4">
                    <i className="fas fa-users text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>5 Passengers</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="fas fa-suitcase text-white me-2" style={{ fontSize: '15px' }}></i>
                    <span className="text-white" style={{ fontSize: '0.8rem', fontWeight: 400 }}>3 Suitcases</span>
                  </div>
                </div>
                <img src="../assets/img/Electric_Car.png" alt="Electric Vehicle" style={{ maxWidth: '95%', maxHeight: '364px', height: 'auto', marginTop: '24px', borderRadius: '16px', alignSelf: 'center', objectFit: 'contain' }} />
              </div>
            </div>
          </div>
        </OwlCarousel>
      </div>
    </div>
  );
};

export default CarSlider;
